import { getCookieDomain } from "@aviv-unified-frontend/internal";

import type { EnvironmentBrandConfigurationInput } from "../types";
import {
  ENVIRONMENT,
  VERSION_EPHEMERAL,
} from "../../../src/constants/environment";

const brandName = "Immowelt";
const origin = "https://www.immowelt.de";

export const config: EnvironmentBrandConfigurationInput = {
  origin,
  consentManagement: {
    id: "dWLDa0s-m",
  },
  airship: {
    appKey: "CQXdr0B9RhylF3_SZVGKSw",
    token:
      "MTpDUVhkcjBCOVJoeWxGM19TWlZHS1N3Onl6cTFOSmE5dzdxaWY4SlhzUXN4SVZkdWZWOTM5ZVdPbmJtM1VBRUIzWGs",
    vapidPublicKey:
      "BBpZz3rPT_-5VRfpRsfEakQfedixUFermMXF21wx9ecLX8VTYzospBYnXySmHpDPDUB20KWbv25izPes-gvMqy0=",
  },
  authentication: {
    urls: {
      refresh: "https://signin.immowelt.de/refresh",
      signIn: "https://signin.immowelt.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "358936558207-jrc2puscu72918c4ig0p9tmbj1q61k6v.apps.googleusercontent.com",
      auth0: {
        clientId: "NtzNjnW22Ynce1vkuATtEM1oTQ3A9ueA",
        audience: brandName,
      },
    },
  },
  featureFlagging: {
    domain: getCookieDomain(
      origin,
      ENVIRONMENT,
      `immowelt-${VERSION_EPHEMERAL}-b2c-shell.unified-lion-dev.aws.aviv.eu`,
      VERSION_EPHEMERAL,
    ),
  },
};
